import { useTranslation } from 'react-i18next';
import styles from './PrivacyNotice.module.css';

const ITEMS = ['controller', 'stored', 'practice', 'why', 'who', 'where', 'howLong', 'rights'] as const;

/**
 * The privacy notice (wireframe 15), in the user's interface language. Shown when someone joins
 * and from the profile.
 */
export function PrivacyNotice() {
  const { t } = useTranslation();
  return (
    <section className={styles.notice} aria-labelledby="privacy-title" data-testid="privacy-notice">
      <h3 id="privacy-title" className={styles.title}>
        {t('privacy.title')}
      </h3>
      {ITEMS.map((item) => (
        <p key={item}>
          <strong>{t(`privacy.${item}Label`)}</strong> {t(`privacy.${item}`)}
          {item === 'who' && (
            <>
              {' '}
              <strong>{t('privacy.whoOperator')}</strong>
            </>
          )}
        </p>
      ))}
    </section>
  );
}
